import { InputHTMLAttributes, ReactNode } from 'react';
import { Controller } from 'react-hook-form';

import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

type Props = {
  name: string;
  checkedIcon?: ReactNode;
  color?: 'primary' | 'secondary' | 'default';
  defaultChecked?: boolean;
  disabled?: boolean;
  disableRipple?: boolean;
  icon?: ReactNode;
  id?: string;
  indeterminate?: boolean;
  indeterminateIcon?: ReactNode;
  inputProps?: InputHTMLAttributes<HTMLInputElement>;
  label?: string;
  labelPlacement?: 'end' | 'start' | 'top' | 'bottom';
  required?: boolean;
  size?: 'small' | 'medium';
};

const HookFormCheckBox = ({
  name,
  checkedIcon,
  color = 'primary',
  defaultChecked,
  disabled,
  disableRipple,
  icon,
  id,
  indeterminate,
  indeterminateIcon,
  inputProps,
  label,
  labelPlacement = 'end',
  required,
  size = 'medium',
}: Props) => (
  <Controller
    name={name}
    defaultValue={defaultChecked}
    render={({ field: { onChange, onBlur, value } }) => {
      const checkbox = (
        <Checkbox
          name={name}
          checked={value}
          checkedIcon={checkedIcon}
          color={color}
          disabled={disabled}
          disableRipple={disableRipple}
          icon={icon}
          id={id ?? name}
          indeterminate={indeterminate}
          indeterminateIcon={indeterminateIcon}
          slotProps={{ input: inputProps }}
          onBlur={onBlur}
          onChange={(e) => onChange(e.target.checked)}
          required={required}
          size={size}
        />
      );

      return label ? (
        <FormControlLabel control={checkbox} label={label} labelPlacement={labelPlacement} />
      ) : (
        checkbox
      );
    }}
  />
);

export default HookFormCheckBox;
